import { useEffect } from 'react';
import moment from 'moment';

const useLocale = () => {
  useEffect(() => {
    moment.locale("en-CA", {
      week: {
        dow: 1,
        doy: 1,
      },
    });
  }, []);
};

export default useLocale;